module.exports = __webpack_public_path__ + "static/media/combined5.29177601.png";